import { useQuery } from '@tanstack/react-query'
import { patientsApi } from '@/api/patientsApi'

/**
 * One patient by MRN (demographics + procedures). Used by the form renderer to
 * populate MR fields. Disabled until an MRN is known — pass `enabled: false`
 * to suppress the fetch entirely (e.g. builder preview).
 *
 * Same key and fetch as `usePatient`, so the case page and its `PatientBanner`
 * share one request. They used to hold separate keys, and every case visit
 * loaded the patient twice (z8nrz7e1c2).
 */
export function usePatientDetail(mrn: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['patients', 'detail', mrn],
    queryFn: () => patientsApi.get(mrn!),
    enabled: enabled && !!mrn,
  })
}
